import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=1df420ea&"
import script from "./IndexPage.vue?vue&type=script&lang=js&"
export * from "./IndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df420ea')) {
      api.createRecord('1df420ea', component.options)
    } else {
      api.reload('1df420ea', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=1df420ea&", function () {
      api.rerender('1df420ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Newsroom/Components/IndexPage.vue"
export default component.exports